module.exports = __webpack_public_path__ + "img/syukyaku-co-001sp.4f7f3883.jpg";